/**
 * Site origin for rel=canonical, og:url, etc.
 * Set REACT_APP_CANONICAL_ORIGIN in .env (e.g. https://dev.100billion.in).
 */
export function getCanonicalOrigin() {
    const raw = process.env.REACT_APP_CANONICAL_ORIGIN;
    if (raw && String(raw).trim()) {
        return String(raw).trim().replace(/\/$/, "");
    }
    if (typeof window !== "undefined" && window.location && window.location.origin) {
        return window.location.origin;
    }
    return "https://dev.100billion.in";
}
